import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["performance", "ticketType", "quantity"]
  static values = {
    availability: Object,
    allocationRemaining: Object
  }

  connect() {
    this.updateTicketTypes()
  }

  performanceChanged() {
    this.updateTicketTypes()
  }

  ticketTypeChanged() {
    this.updateMaxQuantity()
  }

  updateTicketTypes() {
    const performanceId = this.performanceTarget.value
    const select = this.ticketTypeTarget
    const allocationRemaining = this.allocationRemainingValue || {}

    if (!performanceId) {
      Array.from(select.options).forEach(option => {
        if (option.value === "") return
        const typeId = option.value
        const allocRemaining = allocationRemaining[typeId] ?? 0

        if (allocRemaining <= 0) {
          option.textContent = `${option.dataset.baseName} (No allocation)`
          option.disabled = true
        } else {
          option.textContent = `${option.dataset.baseName} (${allocRemaining} allocated)`
          option.disabled = false
        }
      })
      this.autoSelectFirst(select)
      this.updateMaxQuantity()
      return
    }

    const perfAvailability = this.availabilityValue[performanceId] || {}

    Array.from(select.options).forEach(option => {
      if (option.value === "") return
      const typeId = option.value
      const perfAvailable = perfAvailability[typeId] ?? 0
      const allocRemaining = allocationRemaining[typeId] ?? 0
      const effective = Math.min(perfAvailable, allocRemaining)

      if (allocRemaining <= 0) {
        option.textContent = `${option.dataset.baseName} (No allocation)`
        option.disabled = true
      } else if (perfAvailable <= 0) {
        option.textContent = `${option.dataset.baseName} (Sold out for this show)`
        option.disabled = true
      } else {
        option.textContent = `${option.dataset.baseName} (${effective} available)`
        option.disabled = false
      }
    })

    this.autoSelectFirst(select)
    this.updateMaxQuantity()
  }

  updateMaxQuantity() {
    if (!this.hasQuantityTarget) return

    const performanceId = this.performanceTarget.value
    const typeId = this.ticketTypeTarget.value
    const allocationRemaining = this.allocationRemainingValue || {}

    let max = allocationRemaining[typeId] ?? 0

    if (performanceId && typeId) {
      const perfAvailability = this.availabilityValue[performanceId] || {}
      const perfAvailable = perfAvailability[typeId] ?? 0
      max = Math.min(max, perfAvailable)
    }

    max = Math.max(max, 1)
    this.quantityTarget.max = max

    if (parseInt(this.quantityTarget.value) > max) {
      this.quantityTarget.value = max
    }
  }

  autoSelectFirst(select) {
    if (select.selectedOptions[0]?.disabled) {
      const firstAvailable = Array.from(select.options).find(o => !o.disabled && o.value !== "")
      if (firstAvailable) {
        select.value = firstAvailable.value
      }
    }
  }
}
